import PropTypes from 'prop-types';
import React from 'react';

import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import BriefStore from 'contest/stores/brief-store';
import { connectToStores } from 'fluxible-addons-react';

import InfoBox from '@99designs/react-components/components/InfoBox';

const LocalStorageInfoBox = ({ dismissKey, ...props }) => {
    const key = 'info-box-dismiss_' + dismissKey;
    const onDismiss = () => {
        window.localStorage.setItem(key, true);
    };
    const defaultDismissed = !!window.localStorage.getItem(key);
    return <InfoBox {...props} onDismiss={onDismiss} defaultDismissed={defaultDismissed} />;
};
LocalStorageInfoBox.propTypes = {
    dismissKey: PropTypes.string.isRequired,
};

const ColorPreferencesHelpBox = ({ industry, industryName, dismissKey }) => {
    const defaultUrl = '/logo-design/business-of-color';
    const industryUrls = {
        accounting: '/logo-design/business-of-color/accounting',
        agriculture: '/logo-design/business-of-color/agriculture',
        entertainment: '/logo-design/business-of-color/entertainment',
        medical: '/logo-design/business-of-color/healthcare', // 'healthcare' industry doesnt exist.. this should be close enough.
        photography: '/logo-design/business-of-color/photography',
        realestate: '/logo-design/business-of-color/real-estate',
        retail: '/logo-design/business-of-color/retail',
        technology: '/logo-design/business-of-color/technology',
    };

    let url, content;

    if (industryUrls[industry]) {
        url = industryUrls[industry];
        content = (
            <FormattedHTMLMessage
                id="help_colorprefs_industry_content"
                values={{ url, industryName }}
            />
        );
    } else {
        url = defaultUrl;
        content = (
            <FormattedHTMLMessage id="help_colorprefs_noindustry_content" values={{ url: url }} />
        );
    }

    const title = <FormattedMessage id="help_colorprefs_title" />;
    return (
        <LocalStorageInfoBox title={title} dismissKey={dismissKey}>
            <p className="paragraph--no-margin">{content}</p>
        </LocalStorageInfoBox>
    );
};
ColorPreferencesHelpBox.propTypes = {
    industry: PropTypes.string,
    industryName: PropTypes.string,
    dismissKey: PropTypes.string,
};

export const ConnectedColorPreferencesHelpBox = connectToStores(
    ColorPreferencesHelpBox,
    [BriefStore],
    context => ({
        industry: context.getStore(BriefStore).getIndustry(),
        industryName: context.getStore(BriefStore).getIndustryName(),
    })
);

export const DesignExamplesHelpBox = ({ dismissKey }) => {
    const title = <FormattedMessage id="help_designexamples_title" />;
    const content = <FormattedMessage id="help_designexamples_content" />;
    const link = (
        <FormattedHTMLMessage
            id="help_designexamples_link"
            values={{ url: '/blog/tips/write-creative-brief-4-easy-steps/' }}
        />
    );
    return (
        <LocalStorageInfoBox title={title} dismissKey={dismissKey}>
            <p>{content}</p>
            <p className="paragraph--no-margin">{link}</p>
        </LocalStorageInfoBox>
    );
};
DesignExamplesHelpBox.propTypes = {
    dismissKey: PropTypes.string,
};

const HelpBoxSelector = ({ helpBoxType, dismissKey }) => {
    if (helpBoxType === 'logo-color-preferences') {
        return <ConnectedColorPreferencesHelpBox dismissKey={dismissKey} />;
    } else if (helpBoxType === 'design-examples') {
        return <DesignExamplesHelpBox dismissKey={dismissKey} />;
    } else {
        return null; // React needs null specifically to not render
    }
};
HelpBoxSelector.propTypes = {
    helpBoxType: PropTypes.string.isRequired,
    dismissKey: PropTypes.string.isRequired,
};

export const ConnectedHelpBoxSelector = connectToStores(
    HelpBoxSelector,
    [BriefStore],
    (context, props) => {
        const store = context.getStore(BriefStore);
        const element = store.outline[props.sectionKey].elements[props.elementKey];
        return {
            helpBoxType: element.helpBoxType,
            dismissKey: `${props.sectionKey}:${props.elementKey}:${props.listingId}`,
        };
    }
);
HelpBoxSelector.propTypes = {
    elementKey: PropTypes.string.isRequired,
    sectionKey: PropTypes.string.isRequired,
    listingId: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/components/brief/help-box.jsx